export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.0d70254f.worker.js");
}
